import React, { memo } from 'react';
import PropTypes from 'prop-types';
import BaseContactBox from './BaseContactBox';
import { phoneWithInternationalCode } from '../../../utils/helpers/common';

const ContactPhoneBox = memo(({ value, boxText, isArrow, onClickHandler }) => {
  const linkHref = `tel:${phoneWithInternationalCode(value)}`;

  return (
    <BaseContactBox
      {...{ boxText, onClickHandler, linkHref, value, isArrow }}
      classNames="contact-box--phone"
    />
  );
});

ContactPhoneBox.displayName = 'ContactPhoneBox';

ContactPhoneBox.propTypes = {
  value: PropTypes.string.isRequired,
  boxText: PropTypes.string,
  onClickHandler: PropTypes.func,
  isArrow: PropTypes.bool
};

export default ContactPhoneBox;
